// extracted by mini-css-extract-plugin
module.exports = {"root":"EditProjectListingRequirementsPanel_root__2uOfp","form":"EditProjectListingRequirementsPanel_form__2OtBe","title":"EditProjectListingRequirementsPanel_title__2GdL1"};